
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/state-of-hiring",
      function () {
        return require("private-next-pages/state-of-hiring.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/state-of-hiring"])
      });
    }
  